import script from "./FixErrorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FixErrorModal.vue?vue&type=script&setup=true&lang=js"

import "./FixErrorModal.vue?vue&type=style&index=0&id=f04b09e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f04b09e2"]])

export default __exports__